import { useContext, useEffect, useRef, useState } from "react";
import { LocationService } from "../../../services/locationService";
import './map-location-search.scss';
import type { MapLocation } from "../../../interfaces/MapLocation";
import { useTranslation } from "react-i18next";
import { CiSearch } from "react-icons/ci";
import { RxCross1 } from "react-icons/rx";
import { LocationsContext } from "../map-artworks";
import { LanguageContext } from "../../../providers/LanguageProvider";
import { LANGUAGES } from "../../../utils/constants/languages";

export function MapLocationSearch(){
    const inputRef:any = useRef(null);
    const locationObject =useContext(LocationsContext);
    const searchContainerRef = useRef<HTMLDivElement>(null);
    const {t} =useTranslation()
    const [searchLocationResults,setSearchLocationResults]=useState<any>([]);
    const [noResult,setNoResults]=useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const lang = useContext(LanguageContext);
    const localLanguage =LANGUAGES.find((language) => language.code === lang.language)?.locale ?? lang.language;

    function handleSearch(e:any){
    
        e.preventDefault();
        if(e.target.value.length < 3){
            setSearchLocationResults([]);
            setNoResults(false)
            return;
        }else{
  
            LocationService().searchData(e.target.value).then(
                (result) => {
                    if (localLanguage === 'fr-FR'){
                        setSearchLocationResults(result);
                    }else{
                        const newResult = result.data.map((elem:any)=>{
                            const newElem = elem.translations?.find((elt:any)=>elt.languages_code== localLanguage); 
                            return{
                                ...elem,
                                name:newElem.name,
                                description:newElem.description   
                            }
                        })
                        setSearchLocationResults({data:newResult})
                    }
                    setNoResults(result?.data?.length==0)
                }
            )
        }
    }

    function resetInput(){
       inputRef.current.value= "";
       setSearchLocationResults([]);
    }

    function handleClickLocation(e:any,location:MapLocation){
        e.stopPropagation();
        e.preventDefault();
        locationObject?.setSelectedLocation?.(location);
        setIsSearchOpen(false);
        setSearchLocationResults([]);
    }




    useEffect(() => {
        function handleClickOutside(event:any){
            if(
              searchContainerRef.current &&
              !searchContainerRef.current.contains(event.target)
            ){
                setIsSearchOpen(false);
            }
        }
    
        document.addEventListener("mousedown", handleClickOutside);
    
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    


    return(
        <>
            <div className="map-location-search-container"  ref={searchContainerRef}>
   
                <div className="search-container flex">
                    <div className="input-icon-container"><CiSearch/></div>
                    <input name="query" className="map-input-search" 
                    ref={inputRef}
                    onChange={(e)=>handleSearch(e)} placeholder={t('please_seize_query')}
                    onFocus={() => setIsSearchOpen(true)}
                    />
                    {inputRef.current?.value?<div className="input-icon-container-end" onClick={()=>resetInput()}><RxCross1/></div>
                    :''}
                </div>
        
                {isSearchOpen  && searchLocationResults.data?.length>0?
                
                <div className="map-location-search-results">
                    <ul>
                        {searchLocationResults?.data?.map((location:any)=>{
                            return( 
                                <li key={location.id}>
                                    <a onClick={(e)=>handleClickLocation(e,location)} >{location.name}</a>
                                </li> 
                            )})               
                        }
                    </ul>
                </div>
                :""}
                {noResult?
                    <div className="map-location-search-results">
                        <p>{t('no_results')}</p>
                    </div>
                :""}
            </div>
        </>
    )
}